module.exports = __webpack_public_path__ + "static/media/SupportPhone.e1f0e1e2.svg";